import allUrl from "../api/allUrl";
import { post, get, postRaw } from "../api/service/services";
import { Toast } from "antd-mobile-v2";
// 获取密保问题数据
export const getQuestion = () => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getDocType, { code: "pass_quest" }).then((res) => {
      if (res.success === true && res.code == 200) {
        let data = res && res.data ? res.data : [];
        let newData = childrenVal(data, ["dictKey", "dictValue"]);
        resolve(newData);
      }
    });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("密保问题数据获取失败", 1);
    });
};
function childrenVal(data, obj) {
  data.length > 0 &&
    data.map((item) => {
      item.value = item[obj[0]];
      item.label = item[obj[1]];
      if (item.children && item.children.length > 0) {
        childrenVal(item.children, obj);
      }
    });
  return data;
}
